import { IBaseProduct } from 'FeatureModules/ProductPage/types/product.types';
import moment, { DurationInputArg2 } from 'moment';

export const getClientTime = (unit?: DurationInputArg2, value?: number): string => {
  const clientTime = moment().add(moment().utcOffset(), 'minutes');
  if (unit) clientTime.subtract(value, unit);

  return clientTime.utc().toISOString();
};

export const filterProducts = (
  products: { node: IBaseProduct }[] | null | undefined,
  searchTerm: string
): IBaseProduct[] | null | undefined => {
  if (!products) return products;

  if (!searchTerm.length) return products.map(item => item.node);

  const filtered = products.filter(({ node: { title } }) => {
    return title.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return filtered.map(item => item.node);
};
